import ButtonTypes from './buttonTypes';

const orderedPartsStatus = {
  DELIVERED: 'Delivered',
  RETURN: 'Return',
  ON_THE_WAY: 'On the way',
  PARTIALLY: 'Partially',
  CLAIM_CLOSED: 'Claim closed',
  CLAIM_OPENED: 'Claim opened',
  ARCHIVED: 'Archived',
  BACKORDER: 'Backorder',
  CANCEL: 'Cancel'
};

export const orderStatusInfo = {
  [orderedPartsStatus.DELIVERED]: {
    title: 'Delivered',
    state: ButtonTypes.LIGHT_SUCCESS
  },
  [orderedPartsStatus.PARTIALLY]: {
    title: 'Partially',
    state: ButtonTypes.LIGHT_WARNING
  },
  [orderedPartsStatus.ON_THE_WAY]: {
    title: 'On the way',
    state: ButtonTypes.LIGHT
  },
  [orderedPartsStatus.CLAIM_OPENED]: {
    title: 'Claim opened',
    state: ButtonTypes.LIGHT_WARNING
  },
  [orderedPartsStatus.CLAIM_CLOSED]: {
    title: 'Claim closed',
    state: ButtonTypes.LIGHT_WARNING
  },
  [orderedPartsStatus.BACKORDER]: {
    title: 'Backorder',
    state: ButtonTypes.DARK
  },
  [orderedPartsStatus.ARCHIVED]: {
    title: 'Archived',
    state: ButtonTypes.DARK
  },
  [orderedPartsStatus.CANCEL]: {
    title: 'Cancel',
    state: ButtonTypes.DARK
  }
};

export const orderedPartsStatusList = [
  { label: orderedPartsStatus.DELIVERED, value: orderedPartsStatus.DELIVERED },
  { label: orderedPartsStatus.RETURN, value: orderedPartsStatus.RETURN },
  { label: orderedPartsStatus.ON_THE_WAY, value: orderedPartsStatus.ON_THE_WAY },
  { label: orderedPartsStatus.PARTIALLY, value: orderedPartsStatus.PARTIALLY },
  { label: orderedPartsStatus.CLAIM_CLOSED, value: orderedPartsStatus.CLAIM_CLOSED },
  { label: orderedPartsStatus.CLAIM_OPENED, value: orderedPartsStatus.CLAIM_OPENED },
  { label: orderedPartsStatus.BACKORDER, value: orderedPartsStatus.BACKORDER },
  { label: orderedPartsStatus.ARCHIVED, value: orderedPartsStatus.ARCHIVED },
  { label: orderedPartsStatus.CANCEL, value: orderedPartsStatus.CANCEL },
];
export default orderedPartsStatus;
